import { ImportTypeConfig } from '#/store/hooks/useForms/Import/types/ImportTypeConfig'

export const calving: ImportTypeConfig = {
  type: 'calving',
}
